import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=21c4bd3b&scoped=true"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"
import style0 from "./_form.vue?vue&type=style&index=0&id=21c4bd3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4bd3b",
  null
  
)

export default component.exports